import { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { getTranslate } from 'react-localize-redux'

import { DropdownMenu } from 'common/components/DropdownMenu/DropdownMenu'
import * as Routes from 'constants/Routes'
import styles from './UserMenu.module.scss'

import HamburgerIcon from 'icons/HamburgerMenu5.svg'
import AccountSettingsIcon from 'icons/AccountSettings.svg'
import HelpIcon from 'icons/help.svg'
import LogOutIcon from 'icons/LogOut.svg'

const SUPPORT_URL = 'https://www.inbiotair.com/support'

/**
 * The account menu that opens from the navbar hamburger button.
 * It replaces the four menus that used to live in Header, MobileHeader,
 * AuxHeader and WorkspaceHeader. It uses the shared DropdownMenu component
 * and no Material-UI.
 */
const UserMenu = ({ translate }) => {
  const [isOpen, setIsOpen] = useState(false)
  const triggerRef = useRef(null)

  const options = [
    { key: 'account-settings', label: translate('accountSettings'), icon: AccountSettingsIcon },
    { key: 'help', label: translate('help'), icon: HelpIcon },
    { key: 'logout', label: translate('logout'), icon: LogOutIcon }
  ]

  const handleSelect = key => {
    switch (key) {
      case 'account-settings':
        browserHistory.push(Routes.PROFILE)
        break
      case 'help':
        window.open(SUPPORT_URL, '_blank')
        break
      case 'logout':
        browserHistory.push(Routes.LOGOUT)
        break
      default:
        break
    }
  }

  return (
    <div className={styles.userMenu}>
      <button
        ref={triggerRef}
        type='button'
        className={styles.trigger}
        aria-haspopup='true'
        aria-expanded={isOpen}
        aria-label='Menu'
        onClick={() => setIsOpen(open => !open)}
      >
        <img
          src={HamburgerIcon}
          className={styles.triggerIcon}
          alt=''
        />
      </button>
      <DropdownMenu
        isOpen={isOpen}
        options={options}
        onSelect={handleSelect}
        onClose={() => setIsOpen(false)}
        listClassName={styles.menu}
        triggerRef={triggerRef}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  translate: getTranslate(state.localize)
})

export default connect(mapStateToProps)(UserMenu)
